








































































































































































































// vue
import { defineComponent, Ref, ref, computed, onMounted } from '@vue/composition-api'

// componnents
import { PageHeader, AccordionFilters } from '@/components'
import { Select2, Input } from '@/components/general'

// hooks
import { useHeadquarter, useArea, useBondType } from '@/hooks'

// services
import { BondControlService } from '@/services/dailyControl'

// type
import { FiltersBondControl, BondControlGenerate, BondControlForm } from '@/models/dailyControl/BondControlModel'
import { PropOptionSelect } from '@/models'

// utils
import moment from 'moment'
import { dateLibs, alerts, loading, getFullNameFormat } from '@/utils'

export default defineComponent({
  name: 'CreateBondControlMassive',
  components: {
    PageHeader,
    AccordionFilters,
    Select2,
    Input
  },
  setup (props, { root: { $router, $route } }) {
    const title = 'Carga de bonos masivos'
    const router = $router
    const route = $route
    const breadcrumbs = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Control de Bonos',
        to: { name: 'bond-control-massive' }
      },
      {
        text: 'Crear',
        active: true
      }
    ]

    const currentDate = moment()
    const years = dateLibs.createRangeYears()
    const months = dateLibs.getAllMonths()
    const fortnights = dateLibs.fortnightsDefault
    const items: Ref<BondControlGenerate[]> = ref([])
    const isLoaded = ref(false)
    const bond_types_selected: Ref<number> = ref(0)

    const filters: Ref<FiltersBondControl> = ref({
      headquarter: 0,
      area: 0,
      sub_area: 0,
      fortnight: 1,
      year: currentDate.year(),
      month: currentDate.month() + 1,
      loaded_massive: true,
      bond_types: []
    })

    const { loadingHeadquartes, headquartersSelectOptions, getHeadquatersActivated } = useHeadquarter()
    getHeadquatersActivated()
    const { areasOptions, getAreasActive, loadingAreas, areas } = useArea()
    getAreasActive()
    const { bondTypesOp, getBondTypesActivated, loadingBondTypes, bondTypes } = useBondType()
    const bondTypeSelected = computed(() => {
      return bondTypes.value.filter(bondType => Number(bondType.id) === Number(bond_types_selected.value))
    })
    getBondTypesActivated('', '', true)

    const subAreas: Ref<PropOptionSelect[]> = computed(() => {
      const area = areas.value.find(a => Number(a.id) === Number(filters.value.area))
      if (area && area.subAreas) {
        return area.subAreas.map(sa => {
          return {
            value: Number(sa.id),
            text: sa.name
          }
        })
      }
      return []
    })

    const isFiltersValid = (): boolean => {
      const { headquarter, area, sub_area, fortnight, year, month } = filters.value
      if (!headquarter) {
        alerts.error('Debe seleccionar una sede.')
        return false
      }

      if (!area) {
        alerts.error('Debe seleccionar un área.')
        return false
      }

      if (!sub_area) {
        alerts.error('Debe seleccionar un sub área.')
        return false
      }

      if (!fortnight) {
        alerts.error('Debe seleccionar el tipo de quincena.')
        return false
      }

      if (!year) {
        alerts.error('Debe seleccionar un año.')
        return false
      }

      if (!month) {
        alerts.error('Debe seleccionar un mes.')
        return false
      }

      if (bond_types_selected.value <= 0) {
        alerts.error('Debe seleccionar al menos un tipo de bono.')
        return false
      }

      return true
    }

    const generate = async () => {
      if (!isFiltersValid()) {
        return
      }
      loading('show')
      items.value = await BondControlService.generate({
        ...filters.value,
        bond_types: [bond_types_selected.value]
      })
      isLoaded.value = true
      loading('hide')
    }

    const reset = () => {
      items.value = []
      isLoaded.value = false
    }

    const save = () => {
      loading('show')
      const formItems: BondControlForm[] = []

      items.value.forEach(item => {
        const itemForm: BondControlForm = {
          employee_id: item.employee_id,
          headquarter_id: filters.value.headquarter,
          area_id: filters.value.area,
          sub_area_id: filters.value.sub_area,
          year: filters.value.year,
          month: filters.value.month,
          fortnight: filters.value.fortnight,
          loaded_massive: true,
          bond_type_id: 0,
          amount: 0,
          abstents_first_week: item.abstents_first_week,
          abstents_second_week: item.abstents_second_week,
          observations: item.observations
        }
        item.bond_controls.forEach(bondControl => {
          const _item: BondControlForm = {
            ...itemForm,
            bond_type_id: bond_types_selected.value,
            amount: bondControl.amount
          }
          formItems.push(_item)
        })
      })
      BondControlService.saveMassive(formItems).then(() => {
        alerts.success()
        router.push({
          name: 'bond-control-massive'
        })
      }).finally(() => {
        loading('hide')
      })
    }

    onMounted(async () => {
      if (route.name === 'bond-control-massive-edit') {
        const { headquarter, area, sub_area, year, month, fortnight, bondTypeId } = route.params
        filters.value = {
          headquarter: Number(headquarter),
          area: Number(area),
          sub_area: Number(sub_area),
          fortnight: Number(fortnight),
          year: Number(year),
          month: Number(month),
          loaded_massive: true,
          bond_types: [Number(bondTypeId)]
        }
        loading('show')
        const result = await BondControlService.generate(filters.value)
        if (result.length > 0) {
          bond_types_selected.value = Number(result[0].bond_controls[0].bond_type_id)
          items.value = result
        }
        isLoaded.value = true
        loading('hide')
      }
    })

    return {
      title,
      breadcrumbs,
      loadingHeadquartes,
      headquartersSelectOptions,
      filters,
      areasOptions,
      loadingAreas,
      subAreas,
      years,
      months,
      fortnights,
      generate,
      bondTypesOp,
      loadingBondTypes,
      items,
      bondTypeSelected,
      getFullNameFormat,
      isLoaded,
      reset,
      save,
      bond_types_selected
    }
  }
})
